import {CHANGE_SELECTED_ROWS} from "../types/selectedUsersFromListTypes";

export function changeSelectedRows(selected:any) {
  return {
    type: CHANGE_SELECTED_ROWS,
    payload: selected
  };
}
